export default "__VITE_ASSET__BgtotBE2__"